import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';

import HolidayManagementImportForm from 'components/organismos/master/attend/HolidayManagementImportForm';

const HolidayManagementImportPage: React.FC = () => (
  <SidebarTemplate>
    <HolidayManagementImportForm />
  </SidebarTemplate>
);

export default HolidayManagementImportPage;
